import { Button, Heading, Input, Stack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { LoadingOverlay } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { type FunctionComponent, useEffect } from "react";
import { AuthErrorMessage } from "./error-message";
import { Field } from "./field";
import { AuthLayout } from "./layout";

export const SetInitialPasswordScreen: FunctionComponent = observer(
  function SetInitialPasswordScreen() {
    const { authStore } = useStore();
    const router = useRouter();

    useEffect(() => {
      if (router.isReady) {
        authStore.initialPasswordForm.init();
      }
    }, [router.isReady]);

    if (authStore.initialPasswordForm.state === "error") {
      return <AuthErrorMessage />;
    }

    return (
      <AuthLayout>
        <LoadingOverlay
          isLoading={authStore.initialPasswordForm.state === "loading"}
          position="absolute"
        >
          <Stack
            as="form"
            onSubmit={(event) => {
              event.preventDefault();
              authStore.initialPasswordForm.submit();
            }}
            spacing="4"
          >
            <Heading textAlign="center" size="lg">
              <Trans>Create a password</Trans>
            </Heading>
            <Field
              isInvalid={authStore.initialPasswordForm.password.hasError}
              label={t`Password`}
              input={
                <Input
                  autoComplete="new-password"
                  onChange={(e) =>
                    authStore.initialPasswordForm.password.onChange(
                      e.target.value,
                    )
                  }
                  required
                  type="password"
                  value={authStore.initialPasswordForm.password.value}
                />
              }
              errorMessage={authStore.initialPasswordForm.password.error}
            />
            <Field
              isInvalid={authStore.initialPasswordForm.confirmPassword.hasError}
              label={t`Confirm password`}
              input={
                <Input
                  autoComplete="new-password"
                  onChange={(e) =>
                    authStore.initialPasswordForm.confirmPassword.onChange(
                      e.target.value,
                    )
                  }
                  required
                  type="password"
                  value={authStore.initialPasswordForm.confirmPassword.value}
                />
              }
              errorMessage={authStore.initialPasswordForm.confirmPassword.error}
            />
            <Button
              colorScheme="violet"
              isLoading={authStore.initialPasswordForm.state === "submitting"}
              type="submit"
            >
              <Trans>Accept invite</Trans>
            </Button>
          </Stack>
        </LoadingOverlay>
      </AuthLayout>
    );
  },
);
